import { useSocket } from "../utils/SocketProvider";
import { useCallback } from "react";

export const useSocketService = () => {
    const socket = useSocket();

    const getResponseFromConverter = useCallback((comCd, key) => {
        console.log(`🔍 Waiting for converter response: comCd=${comCd}, key=${key}`);

        return new Promise((resolve, reject) => {
            let handler; // ✅ 먼저 선언

            const timeout = setTimeout(() => {
                socket.current.off(comCd, handler); // ✅ 이제 handler 참조 가능
                console.error(`⏰ Timeout waiting for converter response: comCd=${comCd}, key=${key}`);
                reject(new Error(`Timeout waiting for converter response (key: ${key})`));
            }, 15000);

            handler = (data) => { // ✅ let으로 선언 후 할당
                console.log(`📨 Received message from ${comCd}:`, data);

                if (data?.msg?.mtype) {
                    console.log(`Message type: ${data.msg.mtype}, Key: ${data.msg.val?.[0]?.key}`);
                }

                const isValidType = data.msg.mtype === "CSWRP" ||
                    data.msg.mtype === "CARP" ||
                    data.msg.mtype === "CCRRP";
                const hasMatchingKey = data.msg.val?.[0]?.key === key;

                console.log(`🔍 Checking message: type=${data.msg.mtype}, validType=${isValidType}, key=${data.msg.val?.[0]?.key}, matchingKey=${hasMatchingKey}`);

                if (isValidType && hasMatchingKey) {
                    clearTimeout(timeout);
                    socket.current.off(comCd, handler);

                    console.log(`✅ Found matching converter response:`, data);

                    if (data.msg.val[0].val === "fail") {
                        console.error(`❌ Converter response indicates failure`);
                        reject(new Error("Converter response failed"));
                        return;
                    }

                    resolve(data);
                }
            };

            socket.current.on(comCd, handler);
        });
    }, [socket]);

    const sendMsgToServ = useCallback((type, topic, msg) => {
        try {
            console.log('🚀 sendMsgToServ method called');
            console.log(`📋 Parameters: type=${type}, topic=${topic}, msgType=${typeof msg}`);

            // 입력값 검증
            if (!type || typeof type !== 'string') {
                console.error('❌ Invalid type parameter:', type);
                return;
            }
            if (!topic || typeof topic !== 'string') {
                console.error('❌ Invalid topic parameter:', topic);
                return;
            }
            if (msg === null || msg === undefined) {
                console.error('❌ Invalid message parameter:', msg);
                return;
            }

            // 소켓 연결 상태 확인 (앵귤러의 ioSocket → socket.io-client는 socket 직접 참조)
            console.log('🔍 Socket status analysis:');
            console.log(`- Socket exists: ${!!socket.current}`);
            console.log(`- Socket connected: ${socket.current?.connected}`);
            console.log(`- Socket ID: ${socket.current?.id}`);

            if (!socket.current?.connected) {
                console.error('❌ Socket is not ready for communication');
                console.error('💡 Try waiting for socket connection or reconnecting');
                return;
            }

            const payload = [type, topic, msg];

            console.log('📤 Sending message to server:', {
                type,
                topic,
                messageType: typeof msg,
                messageLength: typeof msg === 'string' ? msg.length : JSON.stringify(msg).length,
                socketId: socket.current.id || 'unknown',
                connected: socket.current.connected || false,
                payloadLength: payload.length
            });

            console.log('📡 About to emit "sendMsgToServ" event...');
            socket.current.emit("sendMsgToServ", payload);
            console.log('✅ Message sent successfully via socket.emit()');

            // 전송 후 소켓 상태 확인
            setTimeout(() => {
                console.log('🔍 Post-emission socket status:');
                console.log(`- Still connected: ${socket.current?.connected}`);
                console.log(`- Socket ID: ${socket.current?.id}`);
            }, 100);

        } catch (error) {
            console.error('❌ Error sending message to server:', error);
            console.error('Error stack:', error.stack);
        }
    }, [socket]);

    return {
        getResponseFromConverter,
        sendMsgToServ
    }
}